// src/context/ExpensesContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";
import { API_URL } from "../config";

const ExpensesContext = createContext();

export const ExpensesProvider = ({ children }) => {
  const [expenses, setExpenses] = useState([]);

  const fetchExpenses = async () => {
    try {
      const res = await fetch(`${API_URL}/api/expenses`, {
        credentials: "include",
      });
      const data = await res.json();
      if (data.success) {
        setExpenses(data.data);
      }
    } catch (err) {
      console.error("Failed to fetch expenses:", err);
    }
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  const refreshExpenses = fetchExpenses;

  return (
    <ExpensesContext.Provider value={{ expenses, refreshExpenses }}>
      {children}
    </ExpensesContext.Provider>
  );
};

export const useExpenses = () => useContext(ExpensesContext);
